/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<fc93710506b97d34dae7cd11006cd3aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type layoutHeaderFragment$data = {
  readonly subsections: ReadonlyArray<{
    readonly elements: ReadonlyArray<{
      readonly __typename: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly visualConfig: {
    readonly hidden: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "layoutHeaderFragment";
};
export type layoutHeaderFragment$key = {
  readonly " $data"?: layoutHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"layoutHeaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "layoutHeaderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutSubsection",
      "kind": "LinkedField",
      "name": "subsections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "elements",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hidden",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpLayoutSection",
  "abstractKey": null
};

(node as any).hash = "f703cce131491f9f467281f622f22a23";

export default node;
